import React, { Component } from 'react';
import { Spin, Table, Tooltip, Button, Icon, InputNumber, Col, Row, Modal, Select } from 'antd';
import { sanitizerTexto } from '../../util/utilerias';
import { openNotification } from '../../util/notificaciones';
import MaximoPedidosRequest from '../../services/MaximoPedidos';
import CatalogosRequest from '../../services/Catalogos';
import ResponsiveCard from '../Common/ResponsiveCard';
const { confirm } = Modal;
const { Option } = Select

/**
 * Evento para cancelar el scroll en input number
 */
document.addEventListener("wheel", function (event) {
    if (document.activeElement.type === "number") {
        document.activeElement.blur();
    }
});

/**
 * Clase para ver el proceso de mostrar artículos de máximo de pedidos
 */
export default class MaximoPedidos extends Component {
    state = {
        arrArticulosMaximo: [],
        filterText: "",
        cargando: false,
        bloquear_guardar: true,
        arrDrives: [],
        driveSelected: [],
        scroll: { y: 'auto' },
        disable_combo_drive: false,
        arrRegiones: [],
        arrSucursales: [],
        arrPlazas: [],
        regionSelected: undefined,
        sucursalSelected: undefined,
        plazaSelected: undefined,
        disableDeleteFilters: true,
        disableApplyFilters: true,
        disableNuevaEquivalencia: true,
    }

    /**
     * Comportamiento del componente al mostrar los artículos de máximo pedidos
     */
    componentDidMount = () => {
        let state = { ...this.state }
        CatalogosRequest.ListarRegiones()
            .then(response => {
                state.arrRegiones = response.data
                this.setState(state)
            })
            .catch(err => {
                openNotification(
                    "Ha ocurrido un error al listar las regiones.",
                    "Error al listar regiones",
                    false
                )
            })
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        state.filterText = value;
        let arrEquivalenciasCopy = state.arrEquivalencias
        if (value) {
            arrEquivalenciasCopy = arrEquivalenciasCopy.filter(obj => {
                return sanitizerTexto(value, obj.articulo.codigo)
                    || sanitizerTexto(value, obj.articulo.descripcion)
            })
        }
        state.arrEquivalenciasCopy = arrEquivalenciasCopy
        this.setState(state);
    }

    /**
     * Se ejecuta cuando se busca en el input text
     */
    handleSearchInput = (text) => {
        let state = { ...this.state };
        state.filterText = text;
        this.setState(state);

        clearTimeout(state.timer)
        state.timer = setTimeout(() => {
            this.applyFilters();
        }, 1000);
    }

    /**
     * Se ejecuta cuando se cambia un drive
     */
    onChangeDrive = (value) => {
        let state = { ...this.state };
        state.driveSelected = value;
        if (!value.length) {
            state.arrArticulosMaximo = [];
            state.bloquear_guardar = true;
        }
        this.setState(state)
    }

    /**
     * Se ejecuta cuando se manda buscar artículos al back
     */
    filtrarBack = () => {
        let state = { ...this.state };
        if (state.driveSelected.length) {
            this.setState({ cargando: true, arrArticulosMaximo: [], bloquear_guardar: true }, () => {
                MaximoPedidosRequest.ListarArticulosMaximo(state.driveSelected)
                    .then(response => {
                        if (response.data.length) state.bloquear_guardar = false;
                        state.cargando = false;
                        state.arrArticulosMaximo = response.data
                        this.setState(state)
                    })
                    .catch(err => {
                        this.setState({ cargando: false });
                        openNotification(
                            err?.response?.data?.cuerpo ?? 'Ha ocurrido un error inesperado, favor de reportarlo.',
                            err?.response?.data?.titulo ?? 'Error',
                            false
                        )
                    })
            })
        } else {
            this.setState({ arrArticulosMaximo: [], bloquear_guardar: true })
        }
    }

    /**
     * Acción que se ejecuta al ingresar cantidad
     * @param: value. valor que recibe desde el input
     * @param: record. objeto sobre el que se ejecuta la acción
     */
    onChangeCantArticulo = (value, record) => {
        let state = { ...this.state };
        state.arrArticulosMaximo.forEach(item => {
            item.bordeRojo = false;
            if (item.articulo_id === record.articulo_id) {
                if (value === "" || value === undefined || value === null) value = 0;
                item.multiplo = value
            }
        })
        this.setState(state)
    }

    /**
     * Función que se cambia la región
     * @param: value. valor del id de la región
     * @return: nada.
     */
    handleChangeRegion = (value) => {
        let state = { ...this.state }
        state.sucursalSelected = null;
        state.disableApplyFilters = true;
        state.plazaSelected = null;
        state.driveSelected = [];
        state.bloquear_guardar = true;
        state.arrArticulosMaximo = [];
        if (value === undefined) {
            state.regionSelected = null;
            state.disableDeleteFilters = true
        } else {
            state.regionSelected = value
            CatalogosRequest.ListarSucursalesRegion(value).then(response => {
                state.arrSucursales = response.data
                state.disableDeleteFilters = false
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las sucursales de la región.",
                    "Error al cargar sucursales",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la sucursal
     * @param: value. valor del id de la sucursal
     * @return: nada.
     */
    handleChangeSucursal = (value) => {
        let state = { ...this.state }
        state.plazaSelected = null;
        state.driveSelected = [];
        state.disableApplyFilters = true;
        state.bloquear_guardar = true;
        state.arrArticulosMaximo = [];
        if (value === undefined) {
            state.sucursalSelected = null;
        } else {
            state.sucursalSelected = value
            CatalogosRequest.ListarPlazasSucursal(value).then(response => {
                state.arrPlazas = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las plazas de la sucursal.",
                    "Error al cargar plazas",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la plaza
     * @param: value. valor del id de la plaza
     * @return: nada.
     */
    handleChangePlaza = (value) => {
        let state = { ...this.state }
        state.driveSelected = [];
        state.disableApplyFilters = true;
        state.bloquear_guardar = true;
        state.arrArticulosMaximo = [];
        if (value === undefined) {
            state.plazaSelected = null;
        } else {
            state.plazaSelected = value
            if (localStorage.getItem("role") === 'Administrador') {
                CatalogosRequest.ListarSitios(value).then(response => {
                    state.arrDrives = response.data
                    this.setState(state)
                }).catch(err => {
                    openNotification(
                        "Ha ocurrido un error al cargar los drives de la plaza.",
                        "Error al cargar drives",
                        false
                    )
                })
            } else {
                CatalogosRequest.ListarSitiosPlazaUsuario(value, localStorage.getItem("id_user")).then(response => {
                    state.arrDrives = response.data
                    this.setState(state)
                }).catch(err => {
                    openNotification(
                        "Ha ocurrido un error al cargar los drives de la plaza.",
                        "Error al cargar drives",
                        false
                    )
                })
            }
        }

        this.setState(state)
    }

    /**
     * Función cuando se cambia el combo de drive
     * @param: value. valor del id del drive
     * @return: nada.
     */
    handleChangeDrive = (value) => {
        let state = { ...this.state }
        state.arrma = [];
        state.arrArticulosMaximo = [];
        state.bloquear_guardar = true;
        if (!value.length) {
            state.driveSelected = [];
            state.disableApplyFilters = true
        } else {
            state.driveSelected = value
            if (value.length > 1) {
                state.disableApplyFilters = true
            } else {
                state.disableApplyFilters = false
                state.disableNuevaEquivalencia = false;
            }

        }

        this.setState(state)
    }

    /**
    * Función para limpiar todos los filtros que han
    * sido manipulados por el usuario.
    * @param: nada
    * @return: nada
    */
    cleanFilters = () => {
        let state = { ...this.state }
        state.filterText = '';
        state.disableApplyFilters = true;
        state.disableDeleteFilters = true;
        state.regionSelected = null;
        state.sucursalSelected = null;
        state.plazaSelected = null;
        state.driveSelected = [];
        state.arrArticulosMaximo = [];
        state.disableNuevaEquivalencia = true;
        this.setState(state);
        openNotification("Los filtros se han limpiado correctamente.", "Éxito", true);
    }

    /**
     * Comportamiento al confirmar el máximo de pedidos
     * @param: nada.
     * @return: nada.
     */
    showConfirm = () => {
        let state = { ...this.state }
        let mostrar_error = true;
        for (let index = 0; index < state.arrArticulosMaximo.length; index++) {
            const element = state.arrArticulosMaximo[index];
            if (element.multiplo > 0) {
                mostrar_error = false;
                break;
            }
        }
        if (mostrar_error) {
            openNotification(
                "Es necesario capturar al menos un artículo con cantidad mayor a cero.",
                "Aviso",
                false
            )
        } else {
            confirm({
                title: 'Confirmar',
                content: <div><b>¿Está seguro que las cantidades capturadas son las correctas?</b></div>,
                okText: 'Aceptar',
                cancelText: 'Cancelar',
                okButtonProps: {
                    id: 'boton-aceptar-confirmacion-maximo-pedido-form',
                },
                cancelButtonProps: {
                    id: 'boton-cancelar-confirmacion-maximo-pedido-form',
                },
                onOk: () => {
                    this.setState({ guardando: true, bloquearBotones: true }, this.guardarInventarioArticulos())
                },
            });
        }
    }

    /**
     * Función para guardar la captura de máximo de artículos auxiliares
     */
    guardarInventarioArticulos = () => {
        let state = { ...this.state };
        let obj_enviar = {}
        obj_enviar.usuario_creacion = localStorage.getItem('name');
        obj_enviar.sitios = state.driveSelected
        obj_enviar.articulos = state.arrArticulosMaximo
        this.setState({ cargando: true, bloquear_guardar: true, disable_combo_drive: true }, () => {
            MaximoPedidosRequest.EditarMaximoPedidos(obj_enviar)
                .then(response => {
                    state.cargando = false;
                    state.disable_combo_drive = false;
                    state.driveSelected = [];
                    state.arrArticulosMaximo = [];
                    state.bloquear_guardar = true;
                    this.setState(state)
                    openNotification(
                        response?.data?.cuerpo,
                        response?.data?.titulo
                    )
                })
                .catch(err => {
                    this.setState({ cargando: false, disable_combo_drive: false, bloquear_guardar: false })
                    openNotification(
                        err?.response?.data?.cuerpo ?? 'Ha ocurrido un error inesperado, favor de reportarlo.',
                        err?.response?.data?.titulo ?? 'Error',
                        false
                    )
                })
        })
    }

    render() {
        const columnasArticulos = [
            {
                title: "Código",
                dataIndex: "codigo_articulo",
                key: "codigo_articulo",
            },
            {
                title: "Descripción",
                dataIndex: "descripcion_articulo",
                key: "descripcion_articulo",
            },
            {
                title: "Unidad de compra",
                dataIndex: "unidad_compra",
                key: "unidad_compra",
            },
            {
                title: "Días de Inv.",
                dataIndex: "dias_inventario",
                key: "dias_inventario",
            },
            {
                title: "Múltiplo equivalente",
                dataIndex: "multiplo",
                key: "multiplo",
                render: (_, record) => (
                    <InputNumber
                        type="number"
                        formatter={value => String(value).replace(/[,.-]$/, '')}
                        parser={value => String(value).replace(/[,.-]$/, '')}
                        min={0}
                        max={9999}
                        maxLength={5}
                        precision={0}
                        className={record.bordeRojo ? "bordeRojoInput" : ""}
                        onChange={(cant) => this.onChangeCantArticulo(cant, record)}
                        defaultValue={record.multiplo}
                        value={record.multiplo}
                    />
                )
            },
            {
                title: "Cantidad UDV",
                dataIndex: "cantidad_maxima",
                key: "cantidad_maxima",
            },
        ]

        return (
            <ResponsiveCard id="ParentSize"
                title="Módulo de máximo de pedido"
                extra={
                    <div>
                        <Button
                            className="btnVerCrearGuardar"
                            disabled={this.state.bloquear_guardar}
                            type="primary"
                            id="boton-guardar-maximo-modulo"
                            onClick={() => {
                                this.showConfirm()
                            }}
                        >
                            Guardar Máximo
                        </Button>
                    </div>
                }
            >
                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row gutter={12}>
                            <Col span={8}>
                                <div className="center">Región:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una región">
                                    <Select
                                        id="select-region-maximo-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        onChange={this.handleChangeRegion}
                                        value={this.state.regionSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrRegiones?.length > 0 &&
                                            this.state.arrRegiones.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre_corto}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={8}>
                                <div className="center">Sucursal:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una sucursal">
                                    <Select
                                        id="select-sucursal-maximo-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.regionSelected ? false : true}
                                        onChange={this.handleChangeSucursal}
                                        value={this.state.sucursalSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrSucursales?.length > 0 &&
                                            this.state.arrSucursales.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={8}>
                                <div className="center">Plaza:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una plaza">
                                    <Select
                                        id="select-plaza-maximo-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.sucursalSelected ? false : true}
                                        onChange={this.handleChangePlaza}
                                        value={this.state.plazaSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrPlazas?.length > 0 &&
                                            this.state.arrPlazas.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                        </Row> <br />
                        <Row gutter={12}>
                            <Col span={8}>
                                <div className="center">Drive:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione drive">
                                    <Select
                                        id="select-drive-maximo-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        mode="multiple"
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.plazaSelected ? false : true}
                                        onChange={this.handleChangeDrive}
                                        value={this.state.driveSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrDrives?.length > 0 &&
                                            this.state.arrDrives.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={2}>
                                <Tooltip placement="top" title={this.state.driveSelected.length ? "Realizar búsqueda" : ""}>
                                    <Button
                                        id="boton-filtrar-maximo-pedidos-filtros"
                                        className={this.state.driveSelected.length ? "" : "disableBtn"}
                                        type={this.state.driveSelected.length ? "primary" : "default"}
                                        icon="search"
                                        style={{ width: '80%', marginLeft: '2.5%', marginBottom: "30px", marginTop: '1.8em' }}
                                        onClick={this.filtrarBack}
                                    >
                                    </Button>
                                </Tooltip>
                            </Col>
                            <Col span={2}>
                                <Tooltip placement="top" title="Borrar filtros">
                                    <Button
                                        id="boton-borrar-filtros-maximo"
                                        type="default"
                                        icon="delete"
                                        className={this.state.disableDeleteFilters ? 'disableBtn' : ''}
                                        style={{ width: '80%', marginLeft: '2.5%', marginBottom: "30px", marginTop: '1.7em' }}
                                        onClick={this.cleanFilters}
                                    >
                                    </Button>
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={(_, index) => index}
                            columns={columnasArticulos}
                            dataSource={this.state.arrArticulosMaximo}
                            pagination={{ showTitle: false }}
                        />
                    </Spin>
                </div>
            </ResponsiveCard>
        )
    }
}